(() => {
  'use strict';

  const CARD_SELECTOR = '.rv-product-card';
  const QUICK_VIEW_CLASS = 'rv-custom-quick-view';

  function getProductHandle(card) {
    const link = card.querySelector('.rv-product-card-link[href*="/products/"]');
    if (!link) return '';

    try {
      const url = new URL(link.href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/]+)/);
      return match ? match[1] : '';
    } catch {
      return '';
    }
  }


  function createQuickView(card) {
    if (card.querySelector(`.${QUICK_VIEW_CLASS}`)) return;

    const handle = getProductHandle(card);
    if (!handle) return;

    const button = document.createElement('button');

    button.className = `bsqv_btn custom-recommendation-qv ${QUICK_VIEW_CLASS}`;
    button.type = 'button';
    button.setAttribute('aria-label', 'Quick View');
    button.dataset.productHandle = handle;
    button.dataset.customIconLoaded = 'true';

    button.innerHTML = `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M1 12C3.5 7.5 7.5 5 12 5s8.5 2.5 11 7c-2.5 4.5-6.5 7-11 7S3.5 16.5 1 12z"></path>
        <circle cx="12" cy="12" r="2.5"></circle>
      </svg>
    `;

    card.appendChild(button);
  }


  function createWishlist(card) {
  if (
    card.querySelector('.product-card-wishlist-btn')
  ) {
    return;
  }

  if (
    card.dataset.rvWishlistLoading === 'true'
  ) {
    return;
  }

  const handle = getProductHandle(card);
  if (!handle) return;

  card.dataset.rvWishlistLoading = 'true';


  /*
   * Recently Viewed card only gives us the
   * product handle reliably.
   *
   * Fetch the real Shopify product object so
   * WishlistSuite receives the correct product ID.
   */
  fetch(`/products/${handle}.js`, {
    cache: 'no-store'
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          'Wishlist product request failed'
        );
      }

      return response.json();
    })
    .then(async (product) => {

      if (!product || !product.id) {
        throw new Error(
          'Wishlist product ID not found'
        );
      }


      /*
       * ==========================================
       * FLOATING HEART BUTTON
       * ==========================================
       *
       * This is YOUR existing custom UI.
       * We are NOT using WishlistSuite's
       * createWishlistButton(), so it will NOT
       * become the full-width "Wishlisted ✓"
       * button.
       */

      const button =
        document.createElement('button');

      button.type = 'button';

      button.className =
        'product-card-wishlist-btn';

      button.setAttribute(
        'aria-label',
        'Add to wishlist'
      );

      button.setAttribute(
        'aria-pressed',
        'false'
      );

      button.dataset.wishlisted =
        'false';

      button.dataset.productId =
        String(product.id);

      button.dataset.productHandle =
        handle;

      button.dataset.productTitle =
        product.title || '';

      button.dataset.productImage =
        product.featured_image ||
        product.images?.[0] ||
        '';

      button.dataset.sourcePage =
        'collection';


      /*
       * EXACT FLOATING HEART STYLE
       */

      button.style.cssText = `
        position: absolute;
        top: 10px;
        right: 10px;
        width: 32px;
        height: 32px;
        padding: 0;
        margin: 0;
        border: 0;
        border-radius: 999px;
        background: rgb(255, 255, 255);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 99;
        box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 8px;
        transition: transform 0.15s, opacity 0.15s;
        pointer-events: auto;
      `;


      /*
       * FLOATING HEART ICON
       */

      button.innerHTML = `
        <svg
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          style="
            width:22px;
            height:22px;
            pointer-events:none;
          "
        >
          <path
            d="M20.8 8.6c0 1.7-1 3.2-3 5l-5.8 5.3-5.8-5.3c-2-1.8-3-3.3-3-5A4.6 4.6 0 0 1 7.8 4c1.6 0 3.1.8 4.2 2.1C13.1 4.8 14.6 4 16.2 4a4.6 4.6 0 0 1 4.6 4.6z"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          ></path>
        </svg>
      `;


      /*
       * Add floating heart to card.
       */

      card.appendChild(button);


      /*
       * ==========================================
       * INITIAL WISHLIST STATE
       * ==========================================
       *
       * Read the REAL WishlistSuite state.
       * This means if the product was already
       * wishlisted from:
       *
       * - Product page
       * - Quick View
       * - Another product card
       * - Wishlist page
       *
       * this heart will start filled.
       */

      try {

        if (
          window.WishlistSuite &&
          typeof window.WishlistSuite.ready ===
            'function'
        ) {
          await window.WishlistSuite.ready();
        }


        if (
          window.WishlistSuite &&
          typeof window.WishlistSuite.isWishlisted ===
            'function'
        ) {

          const state =
            await window.WishlistSuite.isWishlisted(
              String(product.id),
              null
            );


          /*
           * Let the existing Grablis bridge
           * paint this exact button.
           */

          button.dataset.wishlisted =
            state ? 'true' : 'false';

          button.setAttribute(
            'aria-pressed',
            state ? 'true' : 'false'
          );

          button.setAttribute(
            'aria-label',
            state
              ? 'Remove from wishlist'
              : 'Add to wishlist'
          );


          const path =
            button.querySelector('svg path');

          if (path) {

            path.setAttribute(
              'fill',
              state
                ? '#FF2E63'
                : 'none'
            );

            path.setAttribute(
              'stroke',
              '#FF2E63'
            );
          }
        }

      } catch (error) {

        console.warn(
          'Recently Viewed wishlist state error:',
          error
        );
      }


      /*
       * IMPORTANT:
       *
       * NO click listener is added here.
       *
       * Your existing Grablis Final Wishlist
       * Bridge already captures:
       *
       * .product-card-wishlist-btn
       *
       * and performs WishlistSuite.toggle().
       *
       * That same bridge also syncs every
       * matching wishlist button everywhere.
       */
    })
    .catch((error) => {

      console.error(
        'Recently Viewed Wishlist error:',
        error
      );

    })
    .finally(() => {

      delete card.dataset.rvWishlistLoading;

    });
}


  function createJudgeMe(card, doc) {
    if (card.querySelector('.rv-judge-me')) return;

    const handle = getProductHandle(card);
    if (!handle) return;

    const title = card.querySelector('.rv-product-title');
    if (!title) return;

    const badge = doc.querySelector(
      '.jdgm-widget.jdgm-preview-badge'
    );

    if (!badge) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'rv-judge-me';

    wrapper.innerHTML = badge.outerHTML;

    title.parentNode.insertBefore(wrapper, title);

    if (
      window.jdgm &&
      typeof window.jdgm.initializeWidgets === 'function'
    ) {
      window.jdgm.initializeWidgets();
    }
  }


  function createThemePrice(card, doc) {
    if (card.dataset.themePriceLoaded === 'true') return;

    const currentPrice = card.querySelector('.rv-product-price');
    if (!currentPrice) return;

    const themePrice =
      doc.querySelector('product-price .price__sale')?.closest('product-price') ||
      doc.querySelector('product-price');

    if (!themePrice) return;

    const themeClass = themePrice.getAttribute('class') || '';
    const themeStyle = themePrice.getAttribute('style') || '';

    currentPrice.className = `${themeClass} rv-product-price`;

    if (themeStyle) {
      currentPrice.setAttribute('style', themeStyle);
    }

    currentPrice.innerHTML = themePrice.innerHTML;

    card.dataset.themePriceLoaded = 'true';
  }


  function createProductBadge(card, doc) {
    if (card.querySelector('.rv-product-badges')) return;

    const themeBadges =
      doc.querySelector('.product-badges.product-badges--top-left') ||
      doc.querySelector('.product-badges');

    if (!themeBadges) return;

    /*
      Recently Viewed ka actual image/media area find karo.
      Image element ke andar append nahi karna.
    */
    const imageLink = card.querySelector('.rv-product-card-link');

    if (!imageLink) return;

    /*
      Badge wrapper
    */
    const wrapper = document.createElement('div');

    wrapper.className = 'rv-product-badges';

    wrapper.style.cssText = `
      position: absolute;
      z-index: 50;
      pointer-events: none;
      display: block;
    `;

    /*
      Theme ka EXACT badge markup clone karo
    */
    wrapper.innerHTML = themeBadges.outerHTML;

    /*
      Ensure link/media becomes positioning parent
    */
    const currentPosition = window.getComputedStyle(imageLink).position;

    if (
      currentPosition === 'static' ||
      !currentPosition
    ) {
      imageLink.style.position = 'relative';
    }

    /*
      Badge ko image ke upar top-left mein insert karo
    */
    imageLink.insertBefore(wrapper, imageLink.firstChild);
  }


  function enhanceCard(card) {
    if (card.dataset.rvEnhancing === 'true') return;

    const handle = getProductHandle(card);
    if (!handle) return;

    createWishlist(card);
    createQuickView(card);

    if (
      card.dataset.themePriceLoaded === 'true' &&
      card.querySelector('.rv-judge-me') &&
      card.querySelector('.rv-product-badges')
    ) {
      return;
    }

    card.dataset.rvEnhancing = 'true';

    fetch(`/products/${handle}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Product request failed');
        }

        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        createThemePrice(card, doc);
        createJudgeMe(card, doc);
        createProductBadge(card, doc);
      })
      .catch((error) => {
        console.error('Recently Viewed enhancement error:', error);
      })
      .finally(() => {
        card.dataset.rvEnhancing = 'false';
      });
  }


  function enhanceCards(root = document) {
    root.querySelectorAll(CARD_SELECTOR).forEach(enhanceCard);
  }


  function init() {
    enhanceCards();

    const observer = new MutationObserver((mutations) => {
      let shouldEnhance = false;

      for (const mutation of mutations) {
        if (
          mutation.type !== 'childList' ||
          !mutation.addedNodes.length
        ) {
          continue;
        }

        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;

          if (
            node.matches?.(CARD_SELECTOR) ||
            node.querySelector?.(CARD_SELECTOR)
          ) {
            shouldEnhance = true;
            break;
          }
        }

        if (shouldEnhance) break;
      }

      if (shouldEnhance) {
        requestAnimationFrame(() => enhanceCards());
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();